export interface CreateEmbodimentOutlineRequest {
    task_id: string;
}

export interface EmbodimentSummary {
    text: string;
    label: string;
}

export interface EmbodimentOutline {
    text?: string;
    label: string;
    claim_numbers?: number[];
    claim_text?: string;
    embodiment_number?: number;
    type?: string;
    outline?: string;
    reference_claim_number?: number[];
}

export interface CreateEmbodimentOutlineResponse {
    outlines: (EmbodimentOutline | EmbodimentSummary)[];
}

export interface SubmitEmbodimentOutlineRequest {
    content: {
        outlines: (EmbodimentOutline | EmbodimentSummary)[];
    };
}

export interface SubmitEmbodimentOutlineResponse {
    // 接口返回内容不关心，可以定义为空对象
}

export interface ModifyEmbodimentOutlineRequest {
    task_id: string;
    claim_text: string;
    claim_numbers: number[];
}

export interface ModifyEmbodimentOutlineResponse {
    outlines: EmbodimentOutline[];
}

export const CreateEmbodimentOutlineApi = Symbol.for('CreateEmbodimentOutlineApi');

export interface CreateEmbodimentOutlineApi {
    createEmbodimentOutline(data: CreateEmbodimentOutlineRequest): Promise<CreateEmbodimentOutlineResponse>;
    submitEmbodimentOutline(taskId: string, data: SubmitEmbodimentOutlineRequest): Promise<SubmitEmbodimentOutlineResponse>;
    getEmbodimentOutline(taskId: string): Promise<CreateEmbodimentOutlineResponse>;
    modifyEmbodimentOutline(data: ModifyEmbodimentOutlineRequest): Promise<ModifyEmbodimentOutlineResponse>;
}
